import { Amplify } from 'aws-amplify'
import { config } from '../config'

// Configure Amplify Auth (Cognito) once at startup.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolClientId,
      loginWith: { email: true },
    },
  },
})
